import {InlineError, Input} from 'avo-ui'
import MultipleSelect from 'components/commons/multiple-select'
import TabToggle from 'components/commons/tab-toogle'

export const PopularProduct = ({ dataProduct, onSearchProduct, optionsProduct, onChangeProduct, errorForm }) => {
    return (
        <TabToggle
            title={'Popular Product'}
            content={
                <div className={'flex flex-col w-1/2 space-y-5'}>
                    <div className={'flex flex-col space-y-3'}>
                        <div className={'font-semibold text-blue-90 required'}>Title Highlight Product</div>
                        <Input
                            className={'flex-1'}
                            name={'section_title'}
                            placeholder={'Masukkan title highlight product'}
                            value={dataProduct?.section_title}
                            onChange={(item) => onChangeProduct({ [item?.name]: item?.value })}
                        />
                        <InlineError className='mt-2' message={errorForm?.product_data?.section_title} />
                    </div>
                    <div className={'flex flex-col space-y-3'}>
                        <div className={'font-semibold text-blue-90 required'}>Pilih Produk</div>
                        <MultipleSelect
                            name={'product_ids'}
                            placeholder={'Search Product...'}
                            onSearch={onSearchProduct}
                            value={dataProduct?.product_ids}
                            options={optionsProduct}
                            onChange={(item) => onChangeProduct({ [item?.name]: item?.value })}
                        />
                        <InlineError className='mt-2' message={errorForm?.product_data?.product_ids} />
                    </div>
                </div>
            }
        />
    )
}
